import Story from "./Story";

function StoryList({ list, title }) {
  if (list.length === 0) {
    return null;
  }
  return (
    <>
      <h4 className="event-header mt-5">{title}</h4>
      {list.map((story) => (
        <Story story={story} key={story.id()} />
      ))}
      <hr />
    </>
  );
}
export default StoryList;
